import { render, staticRenderFns } from "./FamilySearchHeader.vue?vue&type=template&id=228d9cf9"
import script from "./FamilySearchHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilySearchHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FamilySearchHeader.vue?vue&type=style&index=0&id=228d9cf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports